import {transform, transformExtent} from "ol/proj";
import {getDataByUrl} from "@/http/services/http-services-plugin";
import {hasReplaceStringAttributes, replaceStringValue} from "@/helpers/info-overview-helper";

export function generateWmsClick(pixel) {

    const destinationProjection = 'EPSG:28992'
    const size = window.map.getSize()
    const extend = new transformExtent(window.map.getView().calculateExtent(map.getSize()), "EPSG:3857", destinationProjection)

    const wmsGetFeatureInfo = {}
    wmsGetFeatureInfo.width = size[0]
    wmsGetFeatureInfo.height = size[1]

    wmsGetFeatureInfo.I = Math.round(pixel[0])
    wmsGetFeatureInfo.J = Math.round(pixel[1])

    wmsGetFeatureInfo.bbox = extend.join(',')
    wmsGetFeatureInfo.crs = destinationProjection

    var str = "";
    for (var key in wmsGetFeatureInfo) {
        if (str != "") {
            str += "&";
        }
        str += key + "=" + encodeURIComponent(wmsGetFeatureInfo[key]);
    }

    // let url = 'https://data.rivm.nl/geo/alo/wms?service=wms&version=1.3.0&request=GetFeatureInfo&format=image%2Fpng&TRANSPARENT=true&QUERY_LAYERS=rivm_20210423_grenzen_omgevingsdiensten&LAYERS=rivm_20210423_grenzen_omgevingsdiensten&INFO_FORMAT=application%2Fjson&'
    //
    // if(hasReplaceStringAttributes('omgevingsdienst')) {
    //     getDataByUrl(url + str).then(result => {
    //         replaceStringValue('$omgevingsdienst', result.features[0].properties.naam)
    //     })
    // }
    //
    // if(hasReplaceStringAttributes('gemeente')) {
    //     url = 'https://service.pdok.nl/kadaster/bestuurlijkegebieden/wms/v1_0?service=wms&version=1.3.0&request=GetFeatureInfo&format=image%2Fpng&TRANSPARENT=true&QUERY_LAYERS=Gemeentegebied&LAYERS=Gemeentegebied&INFO_FORMAT=application%2Fjson&'
    //
    //     getDataByUrl(url + str).then(result => {
    //         replaceStringValue('$gemeente', result.features[0].properties.naam)
    //     })
    // }
}
